import { ResultCodeEnum } from 'api/api';

export const PRODUCTION_URL = 'https://kursoved.pro';

export const API_URL = `${process.env.API_URL || PRODUCTION_URL}/api`;

enum FrontendResponseCodes {
    Error = 'Error'
}

export const ResponseCodes = { ...FrontendResponseCodes, ...ResultCodeEnum };

export type ResponseCode = keyof typeof ResponseCodes;

export const MAIN_BLOCK_ID = 'main';

export const DEFAULT_TEXTAREA_MAX_ROWS = 20;

export const CONTAINER_BLOCK_ID = 'container';

export enum QueryKey {
    Course = 'course',
    Committee = 'committee',
    Student = 'student',
    Profession = 'profession',
    Organization = 'organization',
    EducationCenter = 'education-center',
    Address = 'address',
    Subject = 'subject'
}

export const PROFESSION_STALE_TIME_MS = 60000;

export const NO_ORGANIZATION_KEY = 'no-organization';

export const USE_VIEW_TRANSITION = !!document.startViewTransition;

export const DEFAULT_PAGINATION_PAGE_SIZE = 10;

export const PAGINATION_PAGE_QUERY_PARAM = 'page';
